export const forceEncode = function (arg: string) {
    return arg
        .replace(/=/g, '%3D')
        .replace(/\//g, '%2F')
        .replace(/\?/g, '%3F')
        .replace(/&/g, '%26')
};